import { render, staticRenderFns } from "./DigitarResultado.vue?vue&type=template&id=4d6c55f4"
import script from "./DigitarResultado.vue?vue&type=script&lang=js"
export * from "./DigitarResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports